var map = {
	"./swiper-left.png": "5f61",
	"./swiper-right.png": "d54d",
	"./swiper1.png": "fc76",
	"./swiper2.png": "70d7",
	"./swiper3.png": "2423",
	"./swiper4.png": "4d10",
	"./swiper5.png": "781b",
	"./swiper6.png": "f7b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86d7";